import Button, { ButtonSize, ButtonVariant } from '../../../components/ui/button'
import ContentPageHeader from '../../../components/ui/contentPageHeader'

import './styles.scss'

type Props = {
  staticLinks?: boolean
}

const staticButtonClass = 'button btn btn-light btn-lg button--width-auto'

const LandingCta = ({ staticLinks = false }: Props) => {
  return (
    <section className='landing-cta' aria-labelledby='landing-cta-heading'>
      <div className='container col-xxl-8 py-5'>
        <div className='landing-cta__card'>
          <span className='landing-cta__badge'>
            TinyInvoice.app
          </span>

          <ContentPageHeader
            as='h2'
            id='landing-cta-heading'
            title='Ready to simplify your invoicing?'
            subtitle='Create and send professional invoices in seconds'
            className='landing-cta__header'
          />

          {staticLinks ? (
            <a href='/login' className={staticButtonClass}>
              Start free
            </a>
          ) : (
            <Button as='link' to='/login' variant={ButtonVariant.SECONDARY} size={ButtonSize.LARGE}>
              Start free
            </Button>
          )}
        </div>
      </div>
    </section>
  )
}

export default LandingCta
